import { getLegacyBridge } from "./state";

const GENERATED_LIBRARY_SCRIPT_VERSION = "runtime-420";
const GENERATED_LIBRARY_SCRIPT_SRC = `/static/generated-library.js?v=${GENERATED_LIBRARY_SCRIPT_VERSION}`;

let generatedLibraryLoadPromise: Promise<void> | null = null;

function currentGeneratedLibraryMethod(name: string) {
  const method = getLegacyBridge().methods[name];
  if (method === renderGeneratedLibrary || method === refreshGeneratedLibraryTasks) return null;
  return typeof method === "function" ? method : null;
}

function loadGeneratedLibraryFeature() {
  if (currentGeneratedLibraryMethod("refreshGeneratedLibraryTasks")) return Promise.resolve();
  if (generatedLibraryLoadPromise) return generatedLibraryLoadPromise;

  generatedLibraryLoadPromise = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[data-agentra-generated-library="true"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(new Error("Generated library script failed to load")), { once: true });
      return;
    }

    const script = document.createElement("script");
    script.src = GENERATED_LIBRARY_SCRIPT_SRC;
    script.async = true;
    script.dataset.agentraGeneratedLibrary = "true";
    script.addEventListener("load", () => {
      try {
        window.__agentraGeneratedLibraryFeatureReady?.();
        resolve();
      } catch (error) {
        reject(error);
      }
    }, { once: true });
    script.addEventListener("error", () => {
      script.remove();
      reject(new Error("Generated library script failed to load"));
    }, { once: true });
    document.head.append(script);
  }).catch((error) => {
    generatedLibraryLoadPromise = null;
    throw error;
  });

  return generatedLibraryLoadPromise;
}

function renderGeneratedLibrary() {
  const method = currentGeneratedLibraryMethod("renderGeneratedLibrary");
  method?.();
}

async function refreshGeneratedLibraryTasks(options: { force?: boolean; loadMore?: boolean } = {}) {
  try {
    await loadGeneratedLibraryFeature();
    const method = currentGeneratedLibraryMethod("refreshGeneratedLibraryTasks");
    return method?.(options);
  } catch {
    getLegacyBridge().methods.setStatus?.("Không tải được Thư viện ảnh. Vui lòng thử lại.", "error");
  }
}

function bindGeneratedLibraryLazyEvents(): void {
  document.addEventListener("click", (event: Event) => {
    const button = (event.target as HTMLElement | null)?.closest?.('[data-mobile-workspace-tab="library"]');
    if (!button) return;
    window.setTimeout(() => void refreshGeneratedLibraryTasks(), 0);
  });
  if (document.body.dataset.mobileWorkspace === "library") {
    window.setTimeout(() => void refreshGeneratedLibraryTasks(), 0);
  }
}

export function initGeneratedLibraryLazyFeature(): void {
  Object.assign(getLegacyBridge().methods, {
    renderGeneratedLibrary,
    refreshGeneratedLibraryTasks,
  });
  bindGeneratedLibraryLazyEvents();
}
